import React, { Component } from 'react';
import { AppContext } from '../../AppProvider';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton,
  Typography
} from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/SaveAlt';
import _get from 'lodash/get';
import EulaContent from './EulaContent';
// import DataAccess from './Eula.data.mock';
import DataAccess from './Eula.data';

import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../utils/hocUtils';
import { withNamespaces } from 'react-i18next';
import { withApollo } from 'react-apollo';

import TypographyStyles from '../../styles/typography';

export class Eula extends Component {
  _handleCancel = () => {
    this.props.auth.logout();
    this.props.client.clearStore();
  };

  _handleAccept = async () => {
    const { client: ApolloClient } = this.props;
    // If the user tried to accept we'll do a best effort save
    // let them through so they don't get stuck in the case
    // that the mutation is failing for some reason.
    // If it fails, they'll get prompted on next login
    const updatedGlobalProps = {
      ...this.context.globalProps,
      eulaAccepted: true
    };
    this.context.updateGlobalProps(updatedGlobalProps);

    DataAccess.acceptEula(ApolloClient).catch(() => {});
  };

  render() {
    const { eulaAccepted, orgInfo } = this.context.globalProps;
    const orgRequiresEula = _get(
      orgInfo,
      'config.orgUsersMustAcceptEula',
      false
    );
    if (eulaAccepted || !orgRequiresEula) return null;

    const { t, classes } = this.props;
    return (
      <Dialog
        open={true}
        onClose={() => {}}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
      >
        <DialogTitle id="scroll-dialog-title">
          <Typography component="div" className={classes.headline5}>
            {t('End User License Agreement')}
          </Typography>

          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            component="a"
            href={`${process.env.PUBLIC_URL}/EULA.pdf`}
            target="_blank"
          >
            <DownloadIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.body2} component="div">
            {EulaContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this._handleCancel}
            color="primary"
            variant="outlined"
          >
            {t('Logout')}
          </Button>
          <Button
            onClick={this._handleAccept}
            color="primary"
            variant="contained"
          >
            {t('I Agree')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const localStyles = theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
});

Eula.contextType = AppContext;
export default withComposedEnhancers(
  Eula,
  withCombinedStyles(true, TypographyStyles, localStyles),
  withNamespaces(),
  withApollo
);
